"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeleteBillingPeriodMutation = exports.useUpdateBillingPeriodMutation = exports.useFetchSingleBillingPeriodQuery = exports.useFetchBillingPeriodsQuery = exports.useCreateBillingPeriodMutation = exports.billingPeriodApi = void 0;
// api/billing-periodApi.ts
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.billingPeriodApi = (0, react_1.createApi)({
    reducerPath: "billingPeriodApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.LETS_CUE_API),
    tagTypes: ["billingPeriods"],
    endpoints: function (builder) { return ({
        createBillingPeriod: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/billing-period/create",
                method: "POST",
                body: obj,
            }); },
            invalidatesTags: ["billingPeriods"],
        }),
        fetchBillingPeriods: builder.query({
            query: function (obj) { return ({
                url: "/v1/billing-period/all",
                method: "GET",
                params: {
                    clientId: obj.clientId,
                    buildingCode: obj.buildingCode,
                    period: obj.period,
                    isActive: obj.isActive,
                    page: obj.page,
                    limit: obj.limit,
                },
            }); },
            providesTags: ["billingPeriods"],
        }),
        fetchSingleBillingPeriod: builder.query({
            query: function (billingPeriodId) { return ({
                url: "/v1/billing-period/fetch",
                method: "GET",
                params: {
                    _id: billingPeriodId,
                },
            }); },
            providesTags: ["billingPeriods"],
        }),
        updateBillingPeriod: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/billing-period/update",
                method: "PUT",
                body: obj,
            }); },
            invalidatesTags: ["billingPeriods"],
        }),
        deleteBillingPeriod: builder.mutation({
            query: function (_a) {
                var billingPeriodId = _a.billingPeriodId;
                return ({
                    url: "/v1/billing-period/remove?_id=".concat(billingPeriodId),
                    method: "DELETE",
                });
            },
            invalidatesTags: ["billingPeriods"],
        }),
    }); },
});
exports.useCreateBillingPeriodMutation = exports.billingPeriodApi.useCreateBillingPeriodMutation, exports.useFetchBillingPeriodsQuery = exports.billingPeriodApi.useFetchBillingPeriodsQuery, exports.useFetchSingleBillingPeriodQuery = exports.billingPeriodApi.useFetchSingleBillingPeriodQuery, exports.useUpdateBillingPeriodMutation = exports.billingPeriodApi.useUpdateBillingPeriodMutation, exports.useDeleteBillingPeriodMutation = exports.billingPeriodApi.useDeleteBillingPeriodMutation;
